import React, { useEffect } from "reactn";
import "./RequestInfo.css";
import { withRouter } from "react-router-dom";
import { IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { toast } from "react-toastify";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/opacity.css";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import axios from "axios";
import {
  getFormattedTimeRange,
  getFormattedDateRange
} from "../../pages/front/SpecificPageUtils/utils";
import { DateTime } from "luxon";
import "../../assets/css/componentSpecificCss/PreviewProgramListingsModal.css";

class PreviewPartyListingsModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      parties: []
    };
  }

  onBeforeDragStart = () => {
    console.log("DRAGGING");
    this.setState({ isDragging: true });
  };

  onDragEndHandler = async (destination, source, draggableId) => {
    console.log("DRAG", destination, source, draggableId);
    if (!destination) {
      console.log("DRAG NO DESTINATION");
      return;
    }

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      console.log("DRAG ALL MATCH");
      return;
    }

    const itemList = this.state.parties;

    const newList = [...itemList];
    const draggedItem = newList[source.index];
    newList.splice(source.index, 1);
    newList.splice(destination.index, 0, draggedItem);

    this.setState({ parties: newList });
  };

  onDragEnd = ({ destination, source, draggableId }) => {
    console.log("DRAG ENDED", destination, source, draggableId);
    this.onDragEndHandler(destination, source, draggableId);
    this.setState({ isDragging: false });
  };

  componentDidMount() {
    this.addScrollWheelListener();

    this.setState({
      parties: this.props.parties
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isDragging !== this.state.isDragging) {
      this.addScrollWheelListener();
    }
  }

  componentWillUnmount() {
    this.removeScrollWheelListener();
  }

  addScrollWheelListener() {
    if (this.state.isDragging) {
      window.addEventListener("wheel", this.handleScroll, { passive: false });
    } else {
      this.removeScrollWheelListener();
    }
  }

  removeScrollWheelListener() {
    window.removeEventListener("wheel", this.handleScroll);
  }

  handleScroll = event => {
    event.preventDefault();
  };

  getDisplayableDateAndTimeRangeForParties = party => {
    //Changes were made in the API to return IANA timezone info (eg. America/Toronto) with every product listing.
    console.assert(party.timezone, "timezone not provided for partner/educator!");

    //For events, server+database stores the time UTC+0 timezone, eg. 2021-10-01 T 04:00:00.000 Z
    const partyStart = DateTime.fromISO(party.party_start);
    const partyEnd = DateTime.fromISO(party.party_end);

    //Now we set the timezone to that of the partner!             e.g. 2021-10-01 T 00:00:00.000 -04:00
    //...and it makes appropriate adjustment if it's not daylight time, eg. -05:00
    const rezonedStart = partyStart.setZone(party.timezone);
    const rezonedEnd = partyEnd.setZone(party.timezone);

    //Tried the following 2 lines -- now commented out! They don't work! Possibly due to older Luxon version.
    //const rezonedStart = DateTime.fromISO( e.event_start, {zone:e.timezone, setZone:true} );
    //const rezonedEnd = DateTime.fromISO( e.event_end, {zone:e.timezone, setZone:true} );

    return {
      formattedTimeRange: getFormattedTimeRange(rezonedStart, rezonedEnd),
      formattedDateRange: getFormattedDateRange(rezonedStart, rezonedEnd)
    };
  };

  render() {
    console.log("MODAL STATE", this.state);
    return (
      <div className="request-modal-cont">
        <div
          className="request-modal lesspadding"
          id="program-listing-preview"
          style={{ maxWidth: "650px", maxHeight: "100%", overflowY: "hidden" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              height: "48px",
              paddingLeft: "20px",
              borderBottom: "1px solid lightgrey"
            }}
          >
            <h3 style={{ color: "#2938be", paddingLeft: "20px" }}>
              Party Listing Preview
            </h3>
            <IconButton
              style={{
                borderRadius: "50%",
                color: "#2880FF",
                marginBottom: "0.5rem"
              }}
              onClick={_ => this.props.onClose()}
            >
              <Close />
            </IconButton>
          </div>
          <div
            style={{ overflowY: "auto", overflowX: "hidden", height: "400px" }}
          >
            <div>
              <div 
                className="container-fluid adminprofiles"
                style={{ background: "#f7f7f8" }}
              >
                <div
                  className="row"
                  style={{
                    paddingLeft: "1rem",
                    paddingRight: "1rem",
                    paddingBottom: "1rem",
                    paddingTop: "5px"
                  }}
                >
                  <>
                    <div style={{ paddingLeft: "1rem", paddingRight: "1rem" }}>
                      <div className="tablecont">
                        <div
                          className="table-responsive"
                          style={{ fontSize: "16px", overflowY: "hidden" }}
                        >
                          {this.state.parties.length > 0 ? (
                            <DragDropContext
                              onDragEnd={this.onDragEnd}
                              onBeforeDragStart={this.onBeforeDragStart}
                            >
                              <Droppable droppableId="programTableItems">
                                {(provided, snapshot) => (
                                  <tbody
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}
                                  >
                                    {this.state.parties
                                      .filter(p => p.published)
                                      .map((row, k) => {
                                        const {
                                          formattedTimeRange,
                                          formattedDateRange
                                        } =
                                          this.getDisplayableDateAndTimeRangeForParties(
                                            row
                                          );

                                        return (
                                          <Draggable
                                            draggableId={`${row.id}`}
                                            index={k}
                                            key={row.id}
                                          >
                                            {(provided, snapshot) => {
                                              return (
                                                <tr
                                                  key={k}
                                                  {...provided.draggableProps}
                                                  {...provided.dragHandleProps}
                                                  ref={provided.innerRef}
                                                >
                                                  <div
                                                    className={`preview-card`}
                                                    style={{
                                                      height: "auto",
                                                      marginBottom: "5px"
                                                    }}
                                                  >
                                                    <LazyLoadImage
                                                      src={`${process.env.REACT_APP_DS_FILES_S3}/${row.party_image}`}
                                                      alt="Party"
                                                      className={
                                                        "preview-image"
                                                      }
                                                      effect="opacity"
                                                    />

                                                    <div className="card-content-preview">
                                                      <div className="card-sub1 card-sub1-preview">
                                                        <h4
                                                          className="sub1-name"
                                                          id="sub1-name-preview"
                                                        >
                                                          {row.party_title}
                                                        </h4>
                                                      </div>
                                                      <div className="card-sub2 card-sub2-preview">
                                                        <h4
                                                          className="sub2-timing sub2-timing-preview"
                                                          style={{
                                                            fontSize: "12px"
                                                          }}
                                                        >
                                                          {formattedTimeRange}
                                                        </h4>
                                                        <div
                                                          className="sub2-date-preview"
                                                          style={{
                                                            fontSize: "10px"
                                                          }}
                                                        >
                                                          {formattedDateRange}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </tr>
                                              );
                                            }}
                                          </Draggable>
                                        );
                                      })}
                                  </tbody>
                                )}
                              </Droppable>
                            </DragDropContext>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </>
                </div>
              </div>
            </div>
          </div>
          <div className="preview-listing-footer">
            <button
              className="preview-listing-btn"
              onClick={async () => {
                const updateOrderEp = `${process.env.REACT_APP_API}/partners/parties/updateOrder`;
                const resultUpdateOrder = await axios.put(
                  updateOrderEp,
                  this.state.parties
                );
                if (resultUpdateOrder.data.success) {
                  toast.success("Listings Order Saved!");
                  this.props.onOrderSave(this.state.parties);
                  this.props.onClose();
                }
              }}
            >
              Save Listing Order
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(PreviewPartyListingsModal);
